<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
   <w-dialog
        v-model="dialog.show"
        :fullscreen="dialog.fullscreen"
        :width="dialog.width || '50%'"
        :persistent="dialog.persistent"
        :persistent-no-animation="dialog.persistentNoAnimation"
        title-class="primary-dark1--bg white"
      >


          <template #title>
          <w-icon class="mr2">fal fa-cog</w-icon>
          {{ dialog.title }}
      </template> 
 
       
        <w-form 
          ref="form" 
          v-model:errors-count="form.errorsCount"
          v-model="dialog.valid"
          @validate="simpan"
          @success="success">
          
          <div class="w-flex wrap smd-column">
            <div class="grow">
              <w-flex wrap :gap="2">
                <!-- Left Column -->
                <div class="mb4" style="min-width: 200px; flex: 1;">
                  <z-select 
                    class="mt4" 
                    :items="premis" 
                    label="Premis *" 
                    v-model="form.premis_id" 
                    :validators="[validators.required]" 
                    @input="changePremis(form)"
                  />
                  
                  <div class="input-group">
                    <template v-if="form.nama == ''">
                      <w-input
                        class="mt2"
                        label="ID Ternakan (No Tag)"
                        type="text"
                        v-model="form.id_ternakan"
                        :validators="[validators.required]"
                      />
                    </template>
                    <template v-else>
                      <w-input
                        class="mt2"
                        label="ID Ternakan (No Tag)"
                        type="text"
                        v-model="form.id_ternakan"
                      />
                    </template>
                    
                    <template v-if="form.id_ternakan == ''">
                      <w-input
                        class="mt4"
                        label="Nama Ternakan"
                        type="text"
                        v-model="form.nama"
                        :validators="[validators.required]"
                      />
                    </template>
                    <template v-else>
                      <w-input
                        class="mt4"
                        label="Nama Ternakan"
                        type="text"
                        v-model="form.nama"
                      />
                    </template>
                    
                    <span class="input-hint">**Sila isi salah satu ID Ternakan atau Nama Ternakan</span>
                  </div>
                  
                  <w-input 
                    class="mt4" 
                    label="Tarikh Lahir *" 
                    type="date" 
                    v-model="form.tarikh_lahir" 
                    :validators="[validators.required]"
                  />
                  
                  <z-select 
                    class="mt4" 
                    :items="jantina" 
                    label="Jantina *" 
                    v-model="form.jantina" 
                    :validators="[validators.required]"
                  />
                  
                  <template v-if="form.jantina == 2">
                    <div class="pregnancy-status" v-if="form.id > 0">
                      <b>Bunting : </b>
                      <w-radios 
                        class="mr2" 
                        v-model="form.bunting" 
                        :items="bunting_list" 
                        inline 
                        color="blue-light1"
                      />
                    </div>
                  </template>
                  <!-- <w-input class="mt4" label="Warna" type="text" v-model="form.warna" /> -->

                  <z-select 
                    class="mt4" 
                    :items="lkp_ternakan" 
                    label="Jenis Ternakan *" 
                    v-model="form.lkp_ternakan_id" 
                    @input="getJurusan(form.lkp_ternakan_id)" 
                    :validators="[validators.required]"
                  />
                  <z-select 
                      class="mt4" 
                      :items="lkp_jurusan" 
                      label="Jurusan Ternakan *"  
                      v-model="form.lkp_jurusan_id" 
                      @input="getBaka(form.lkp_jurusan_id)" 
                      :validators="[validators.required]"
                    />
                  <z-select 
                    class="mt4" 
                    :items="lkp_status" 
                    label="Status *" 
                    v-model="form.lkp_status_id" 
                    :validators="[validators.required]" 
                    v-if="form.id > 0"
                  />
                </div>
                
                
                <div class="mb4" style="min-width: 200px; flex: 1;">
                  
                    
                    <z-select
                    class="mt4"
                    :items="lkp_baka"
                    label="Baka *"
                    v-model="form.lkp_baka_id"
                    :validators="[validators.required]"
                  />
                  <z-select 
                    class="mt4" 
                    :items="lkp_gred" 
                    label="Generasi *" 
                    v-model="form.lkp_gred_id" 
                    :validators="[validators.required]"
                  />
                  <z-select class="mt4"  v-model="form.lkp_warna_id" :items="lkp_warna" label="Warna Bulu" />
                  <w-input class="mt4" label="Nama Bapa" type="text" v-model="form.nama_bapa" />
                  <w-input class="mt4" label="ID Bapa" type="text" v-model="form.id_bapa" />
                  <w-input class="mt4" label="Nama Ibu" type="text" v-model="form.nama_ibu" />
                  <w-input class="mt4" label="ID Ibu" type="text" v-model="form.id_ibu" />
                  <w-select 
                      class="mt4" 
                      :items="lkp_kaedah_pembiakan" 
                      label="Kaedah Pembiakan"  
                      v-model="form.lkp_kaedah_pembiakan_id"  
                      disabled
                    />
                  <w-select 
                    class="mt4" 
                    :items="status_ternakan" 
                    label="Status Ternakan Baka" 
                    v-model="form.status_ternakan" 
                    v-if="form.id > 0"
                    disabled
                  />
                </div>
              </w-flex>
            </div>
          </div>
        </w-form>

        
        <template #actions>
          <div class="spacer" />
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">
            TUTUP
          </w-button>
          <w-button 
            class="ml1" 
            :loading="dialog.loading"
            :disabled="dialog.loading || dialog.valid === false"
            @click="$refs.form.validate()"
          >
            {{ dialog.loading ? 'MENYIMPAN...' : 'SIMPAN' }}
          </w-button>
        </template>
      </w-dialog>

	  <z-page title=" Ternakan">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  />
              <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="Premis" />
              <!-- <w-input style="margin:5px; " v-model="pencarian.kode" label="No Pendaftaran" /> -->
              <w-input style="margin:5px; " v-model="pencarian.nama" label="ID / Nama Ternakan" />
              <z-select style="margin:5px; "  class="mt4" :items="lkp_ternakan" label="Jenis Ternakan"  v-model="pencarian.lkp_ternakan_id" @input="getJurusanCarian(pencarian.lkp_ternakan_id)" /> 
           </w-flex>
           <w-flex class="mt3" >
              <z-select style="margin:5px; " class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan"  v-model="pencarian.lkp_jurusan_id" @input="getBakaCarian(pencarian.lkp_jurusan_id)" />       
              <z-select style="margin:5px; " v-model="pencarian.lkp_baka_id" :items="lkp_baka" label="Baka" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_gred_id" :items="lkp_gred" label="Generasi" />
              <z-select style="margin:5px; " v-model="pencarian.jantina" :items="jantina" label="Jantina" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
               <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
            &nbsp;
               <w-button class="mr2" bg-color="primary" v-on="on" @click="$refs.frm.validate()">
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
          </w-flex>
        </div>
        
          
  		  <z-table title="Senarai Ternakan" :headers="table.headers" :items="table.items" :meta="table.meta">
            <template #button v-if="$zutil.role('2') || $zutil.role('1') || $zutil.role('5')" >
                     <w-button dark class="green--bg ml1" v-on="on" @click="add()">
                    <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                </w-button>
            </template>

            
            <template #item-cell.umur="{ item, label, header, index }">
                      {{$zutil.umurbulan(item.tarikh_lahir)}}
           </template>
  		    <template #header-label="{ header, label, index }">
  		      <template v-if="header.key == 'action'">
  			      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
              Tindakan
            </template>
  		      <template v-else>
  		      	{{ label }}
  		      </template>
  		    </template>
          <template #item-cell.tarikh_lahir="{ item, label, header, index }">
            {{$zutil.dateformat(item.tarikh_lahir)}}
          </template>
  		    <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                     <w-button  bg-color="info" v-if="item.bunting !=1"  v-on="on" @click="copy(item)" class="be fs-2"><div style="width: 8px"></div> 
                <w-icon md class="mr2">fal fa-copy</w-icon>
              </w-button>
                </template>
               SALIN 
            </w-tooltip>
              &nbsp; 
              <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                     <w-button  bg-color="warning" v-on="on" @click="edit(item)" class="be fs-2"><div style="width: 8px"></div>
                <w-icon md class="mr2">fal fa-pencil</w-icon>
              </w-button>
                </template>
               KEMASKINI 
            </w-tooltip>
               &nbsp; 
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                     <inertia-link :href="$route('daftar.ternakan.show',item.id)" v-on="on" class="w-button w-button--dark size--md info-dark1--bg"> <div style="width: 8px"></div>
                <w-icon md class="mr2">fal fa-eye</w-icon>  
              </inertia-link>
                </template>
               PAPAR 
            </w-tooltip>
             &nbsp; 
            <w-tooltip top color="white" bg-color="black">
              <template #activator="{ on }">
               <w-button class="be fs-2" v-on="on" bg-color="error-dark1" dark tile v-if="(item.padam == 1 )" @click="destroy1(item.id)"><div style="width: 8px"></div>
                   <w-icon md class="mr2">fal fa-trash</w-icon> 
                   </w-button>
                     </template>
                     PADAM
            </w-tooltip>
  		      </w-flex>
  		    </template>
  		  </z-table>
      </div>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  
  extends: ZResource,
  props: {
    items: [Array, Object],
  },

  data() {
    return {
      resourceurl: 'daftar.ternakan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Daftar Premis & Ternakan', route: '/daftar' },
        { label: 'Ternakan', route: '/daftar/ternakan' },
      ],
      title : 'Tambah Ternakan',
      form : {
        id : 0,
        premis_id : '',
        lkp_ternakan_id : null,
        lkp_baka_id : null,
        lkp_gred_id : '',
        lkp_warna_id : '',
        lkp_kaedah_pembiakan_id : null,
        kode : '',
        nama : '',
        id_ternakan : '',
        tarikh_lahir : '',
        jantina : '',
        lkp_jurusan_id : null,
        lkp_status_id: '',
        status_ternakan: '',
        nama_bapa:'',
        id_bapa:'',
        nama_ibu:'',
        id_ibu:'',
        warna: '',
        bunting: null,
        copy : 0
      },
         pencarian: {
         premis_id: '',
         no_ternakan: '',
         lkp_ternakan_id: '',
         lkp_negeri_id: '',
         lkp_baka_id: '',
         lkp_jurusan_id: '',
         lkp_gred_id: '',
         kode :'',
         jantina: '',
      },
      negeri:[],
      lkp_jurusan :[],
      lkp_ternakan : [],
      lkp_baka : [],
      lkp_kaedah_pembiakan : [],
      premis : [],
      premis_id : [],
      lkp_gred : [],
      lkp_warna : [],
      lkp_status : [],
      status_ternakan : [],
      lkp_negeri : [],
      lkp_bandar : [],
      lkp_poskod : [],
      // penternak :[],
      bunting_list:[
        {value: 1, label: "YA"},
        {value: null, label: "TIDAK"},
      ],
      jantina : [],
      id_premis_sebelum:0,
      
    }
  },
  methods: {
      changePremis(form){
         if (form.id > 0) {
            if(this.id_premis_sebelum == form.premis_id){
               form.status_ternakan = 0;
            }else{
               form.status_ternakan =41;
            }
         }
      },
      add(){
          this.form = {
              id : 0,
              premis_id : '',
              lkp_ternakan_id : '',
              lkp_baka_id : '',
              lkp_kaedah_pembiakan_id : 3,
              lkp_gred_id : '',
              lkp_warna_id : '',
              kode : '',
              nama : '',
              id_ternakan : '',
              tarikh_lahir : '',
              bunting : null,
              jantina : '',
              lkp_jurusan_id : '',
              lkp_status_id : '',
              status_ternakan : '',
              nama_bapa : '',
              id_bapa : '',
              nama_ibu : '',
              id_ibu : '',
              warna : '',
              copy : 0

          }
          
          this.dialog.show = true
          this.dialog.title = 'Tambah'
          this.form.saveButton = "Simpan"
      },
      edit(item){
        this.form = {
          id : item.id,
          premis_id : item.premis_id ?? '',
          lkp_ternakan_id : item.lkp_ternakan_id ?? '',
          lkp_baka_id : item.lkp_baka_id ?? '',
          lkp_kaedah_pembiakan_id : item.lkp_kaedah_pembiakan_id ?? '',
          lkp_gred_id : item.lkp_gred_id ?? '',
          lkp_warna_id : item.lkp_warna_id ?? '',
          kode : item.kode ?? '',
          nama : item.nama ?? '',
          id_ternakan : item.id_ternakan ?? '',
          nama_bapa : item.nama_bapa ?? '',
          id_bapa : item.id_bapa ?? '',
          nama_ibu : item.nama_ibu ?? '',
          id_ibu : item.id_ibu ?? '',
          warna : item.warna ?? '',
          tarikh_lahir : item.tarikh_lahir ?? '',
          jantina : item.jantina ?? '',
          bunting : item.bunting ?? 0,
          lkp_jurusan_id : item.lkp_jurusan_id ?? '',
          lkp_status_id : item.lkp_status_id ?? '',
          status_ternakan : item.status_ternakan ?? '',
          copy : 0
        }

        this.dialog.show = true
        this.dialog.title = 'Kemaskini'
        this.form.saveButton = 'Kemaskini'
        this.id_premis_sebelum = item.premis_id

        if (this.form.lkp_ternakan_id) {
          this.getJurusan(this.form.lkp_ternakan_id)
        }

        if (this.form.lkp_jurusan_id) {
          this.getBaka(this.form.lkp_jurusan_id)
        }
      },
      copy(item){
        this.form = {
          id : 0,
          premis_id : item.premis_id ?? '',
          lkp_ternakan_id : item.lkp_ternakan_id ?? '',
          lkp_baka_id : item.lkp_baka_id ?? '',
          lkp_kaedah_pembiakan_id : item.lkp_kaedah_pembiakan_id ?? '',
          lkp_gred_id : item.lkp_gred_id ?? '',
          lkp_warna_id : item.lkp_warna_id ?? '',
          kode : '',
          nama : '',
          id_ternakan : '',
          nama_bapa : item.nama_bapa ?? '',
          id_bapa : item.id_bapa ?? '',
          nama_ibu : item.nama_ibu ?? '',
          id_ibu : item.id_ibu ?? '',
          warna : item.warna ?? '',
          bunting : item.bunting ?? 0,
          tarikh_lahir : item.tarikh_lahir ?? '',
          jantina : item.jantina ?? '',
          lkp_jurusan_id : item.lkp_jurusan_id ?? '',
          lkp_status_id : '',
          status_ternakan : item.status_ternakan ?? '',
          copy : 1
        }

        this.dialog.show = true
        this.dialog.title = 'Salin'
        this.form.saveButton = 'Simpan'

        if (this.form.lkp_ternakan_id) {
          this.getJurusan(this.form.lkp_ternakan_id)
        }

        if (this.form.lkp_jurusan_id) {
          this.getBaka(this.form.lkp_jurusan_id)
        }
      },


      cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       params.per_page =9999;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },

      getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

       getBaka(i){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },

       getKaedahPembiakan(){
         this.$zcomm.get(this.api_service + 'lookup/kaedah_pembiakan', {}).then(res => {
           this.lkp_kaedah_pembiakan = res
         })
       },

       getbakaAll(){
         this.$zcomm.get(this.api_service + 'lookup/baka_all/', {}).then(res => {
           this.lkp_baka = res
         })
       },

       getjurusanAll(){
         this.$zcomm.get(this.api_service + 'lookup/jurusan_all/', {}).then(res => {
           this.lkp_jurusan = res
         })
       },

       // getPenternak(){
       //   this.$zcomm.get(this.api_service + 'lookup/penternak', {}).then(res => {
       //     this.penternak = res
       //   })
       // },

       destroy1(id)
          {
            this.$swal({
              title: 'Anda Pasti?',
              // text: "Are you sure want to delete this item!",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ya',
              cancelButtonText: 'Tidak'
            }).then((result) => {
              if (result.value) {
                this.$zcomm.delete(this.resourceurl + '.destroy',id)
                .then(res => {
                  this.sending = false;
                  this.$inertia.visit(this.$page.url)
                  this.removeitem(res) // remove the data from list. no need to refresh page
                  if (typeof this.onAfterDelete === "function") {
                    this.onAfterDelete()
                  }
                })
                .finally(() => {
                  // $('#' + this.resourceurl).modal('hide')
                });
              }else{ }
              })

          },


       getGred(){
         this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
           this.lkp_gred = res
         })
       },

       getWarna(){
         this.$zcomm.get(this.api_service + 'lookup/warna', {}).then(res => {
           this.lkp_warna = res
         })
       },

       getStatus(){
         this.$zcomm.get(this.api_service + 'lookup/status_te', {}).then(res => {
           this.lkp_status = res
         })
       },

       getStatusTernak(){
         this.$zcomm.get(this.api_service + 'lookup/status_ternak', {}).then(res => {
           this.status_ternakan = res
         })
       },

       getJantina(){
         this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
           this.jantina = res
         })
       },

       getPremis(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis = res
         })
       },

       getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

       getJurusan(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },

       getJurusanCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },

       getBakaCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },


       getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'ternakan/show/'+this.id, {}).then(res => {
          if(res.lkp_ternakan_id > 0){
            this.getBaka(res.lkp_ternakan_id)
          }
          this.form = res

        })
      }
    },


      simpan(){
         this.dialog.loading = true
         if(this.dialog.valid == true){
            if (this.form.id > 0) 
            {
              this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
              .then(res => {
                if (typeof this.onAfterEdit === "function") {
                  this.onAfterEdit()
                }
               this.$inertia.visit(route(route().current()));
               this.dialog.loading = false
               this.dialog.show = false
                // this.loading = 0;
              })
            }
            else 
            {
              this.$zcomm.post(this.resourceurl+'.store' , this.form)
              .then(res => {
                if (typeof this.onAfterAdd === "function") {
                  this.onAfterAdd()
                }
                this.$inertia.visit(route(route().current()));
               this.dialog.loading = false
               this.dialog.show = false

                // this.loading = 0;

              })
            }
         }else{
            this.dialog.loading = false
         }
       },
  
  },
     watch: {
   },
     mounted() {
     const isMobile = window.innerWidth < 768
     this.dialog.width = isMobile ? '95%' : '50%'
     window.addEventListener('resize', () => {
       this.dialog.width = window.innerWidth < 768 ? '95%' : '50%'
     })

     
     this.getPremis()
     this.getJantina()
     this.getTernakan()
     this.getGred()
     this.getBaka()
     this.getJurusan()
     this.getStatus()
     this.getStatusTernak()
     this.getData()
     this.getPremisCarian()
     this.getKaedahPembiakan()
     this.getbakaAll()
     this.getjurusanAll()
     this.getWarna()
     this.getNegeri()

    // this.getPenternak()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.premis_id){
      this.form.premis_id =  parseInt(this.params.premis_id)
    }
  }
}
</script>

<style scoped>
.input-group {
  border: 1px solid #000;
  border-radius: 4px;
  padding: 10px;
  margin-top: 16px;
  background-color: #f9f9f9;
}

.input-hint {
  color: red;
  font-size: 0.8em;
  display: block;
  margin-top: 8px;
}

.pregnancy-status {
  margin-top: 10px;
  padding-right: 20px;
  color: #234781;
  font-weight: normal;
  font-size: 1rem;
}







</style>
